export default class Forms {
  static init() {
    Array.prototype.forEach.call(document.querySelectorAll('input[type="file"]'), (input) => this.initInputFile(input));
  }

  static initInputFile(input) {
    input.addEventListener('change', () => input.parentNode.querySelector('.file-success').innerHTML = input.value.split('\\').pop().split('/').pop());
  }
}
